import React, { Component } from "react"
import SbEditable from "storyblok-react"
import IconV2 from "../icon-v2"
import { StyledProgramDetailAttr } from "./partials"

class ProgramDetailAttr extends Component {
  render() {
    const { blok } = this.props
    return (
      <SbEditable content={blok}>
        <StyledProgramDetailAttr programCategory={this.props.programCategory}>
          {blok.icon && <IconV2 icon={blok.icon} />}
          {blok.title && <p>{blok.title}</p>}
        </StyledProgramDetailAttr>
      </SbEditable>
    )
  }
}

export default ProgramDetailAttr
